const ESTADOS_DIAS_CORTESIA = [
  {
    id: 0,
    name: 'Esperando respuesta de la AEAT'
  },
  {
    id: 3,
    name: 'Correcto'
  },
  {
    id: 5,
    name: 'En Error'
  },
  {
    id: 6,
    name: 'Cancelada',
  }
]

export {
  ESTADOS_DIAS_CORTESIA
}
